import WizardStep from "./WizardStep";

export default class ProcessRevenueStep extends WizardStep {
  type = WizardStep.TYPE_PROCESS;

  name = 'Process Revenue';
  title = 'Process Revenue';
  subtitle = "Aggregates imported revenue data into Nagato's payable revenue";

  estimate = 4;

  getHelpText() {
    return [
      'Enjoy your cup of coffee.',
      'Click proceed.',
    ]
  }
}